export function authResponseObserver($q, $window, $state, $log) {
  'ngInject';
  return {
    responseError: function(errorResponse) {
      $log.debug(`auth response error ${errorResponse.status}`, { errorResponse });
      switch (errorResponse.status) {
        case 401: {
          break;
        }
        case 403: {
          // Actual we need to disable this forwarding
          // $state.go('app.login', undefined, { location: true });
          break;
        }
      }
      return $q.reject(errorResponse);
    }
  };
}
